import { useTheme } from 'styled-components'

import { Typography } from '../../Typography'

import {
  StyledBody,
  StyledContainer,
  StyledContent,
  StyledHeadingContainer,
  StyledIconWrapper,
} from './InfoCard.Styled'
import type { InfoCardProps } from './InfoCard.Types'

export const InfoCard = ({
  variant = 'grey',
  heading,
  body,
  secondaryBody,
  showBackground = true,
  icon,
  iconColor,
  iconPosition = 'separate',
  align = 'left',
  children,
  ...htmlProps
}: InfoCardProps) => {
  const theme = useTheme()
  const isIconNextToHeading = iconPosition === 'next-to-heading'

  return (
    <StyledContainer
      {...htmlProps}
      $align={align}
      $variant={variant}
      $showBackground={showBackground}
    >
      {icon && !isIconNextToHeading && (
        <StyledIconWrapper $iconColor={iconColor} $variant={variant}>
          {icon}
        </StyledIconWrapper>
      )}
      <StyledContent>
        {heading && heading.length && (
          <StyledHeadingContainer $align={align}>
            {icon && isIconNextToHeading && (
              <StyledIconWrapper $iconColor={iconColor} $variant={variant}>
                {icon}
              </StyledIconWrapper>
            )}
            <Typography
              $variant="Poppins/T3 - Semibold"
              $color={theme.colors['N Content/Primary']}
            >
              {heading}
            </Typography>
          </StyledHeadingContainer>
        )}
        {body && body.length && (
          <StyledBody
            $showBackground={showBackground}
            $variant="Poppins/T3"
            dangerouslySetInnerHTML={{ __html: body }}
            $colorVariant={variant}
          />
        )}
        {secondaryBody && (
          <Typography
            $variant="Poppins/T4"
            $color={theme.colors['N Content/Secondary']}
          >
            {secondaryBody}
          </Typography>
        )}
        {children}
      </StyledContent>
    </StyledContainer>
  )
}
